import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useReportContext } from '../../../../context/DetailContext';
import { MapItemTypeData } from '../../data';

declare global {
  interface Window {
    kakao: any;
  }
}

interface ItemStateMapProps {
  groupCategory: string;
}

const ItemStateMap = ({ groupCategory }: ItemStateMapProps) => {
  const { lat, lng, geom } = useReportContext();
  const [roadView, setRoadView] = useState(false);
  const [isEnableRoadView, setIsEnableRoadView] = useState(true);
  const expandIcon = '/assets/images/icon/Icon_Expand.svg'
  const navigate = useNavigate();
  const getMarkerImage = () => {
    if (!groupCategory) return '/assets/images/marker/etc.svg';
    const item = MapItemTypeData.find((data) => data.value === groupCategory);
    return item ? item.markerImg : '/assets/images/marker/etc.svg';
  };
  useEffect(() => {
    if (window.kakao && window.kakao.maps) {
      const container = document.getElementById('StateMap');
      const options = {
        center: new window.kakao.maps.LatLng(lat, lng),
        draggable: false,
        level: 3,
        mapTypeId: window.kakao.maps.MapTypeId.SKYVIEW,
      };
      if (roadView) {
        var roadview = new window.kakao.maps.Roadview(container, options); //로드뷰 객체
        var roadviewClient = new window.kakao.maps.RoadviewClient();
        var position = new window.kakao.maps.LatLng(lat, lng);

        roadviewClient.getNearestPanoId(position, 100, function (panoId: any) {
          // roadview.setPanoId(panoId, position); //panoId와 중심좌표를 통해 로드뷰 실행
          if (panoId) {
            roadview.setPanoId(panoId, position); // panoId가 있으면 로드뷰 실행
            setIsEnableRoadView(true);

            // 마커 추가 (옵션)
            const markerImage = new window.kakao.maps.MarkerImage(
              getMarkerImage(),
              new window.kakao.maps.Size(58, 58),
            );

            const markerPosition = new window.kakao.maps.LatLng(lat, lng);

            let roadViewMarker = new window.kakao.maps.Marker({
              position: markerPosition,
              map: roadview,
              image: markerImage,
            });

            // ✅ 마커가 중앙에 오도록 설정
            var projection = roadview.getProjection();
            var viewpoint = projection.viewpointFromCoords(
              roadViewMarker.getPosition(),
              roadViewMarker.getAltitude(),
            );
            roadview.setViewpoint(viewpoint);
          } else {
            alert('로드뷰가 지원되지 않는 지역입니다.');
            setIsEnableRoadView(false); // panoId가 없으면 일반 지도 표시
            // 지도 생성
            let map = new window.kakao.maps.Map(container, options);
            map.removeOverlayMapTypeId(window.kakao.maps.MapTypeId.ROADVIEW);
            // 마커 추가 (옵션)
            const markerImage = new window.kakao.maps.MarkerImage(
              getMarkerImage(),
              new window.kakao.maps.Size(58, 58),
            );

            new window.kakao.maps.Marker({
              position: new window.kakao.maps.LatLng(lat, lng),
              map: map,
              image: markerImage,
            });
            // 폴리곤 생성
            if (geom.length > 0) {
              const polygonPath = geom.map(
                ([lng, lat]) => new window.kakao.maps.LatLng(lat, lng),
              );

              const polygon = new window.kakao.maps.Polygon({
                path: polygonPath, // Define the polygon path
                strokeWeight: 3, // Border thickness
                strokeColor: '#00B155', // Border color
                strokeOpacity: 0.8, // Border transparency
                fillColor: '#00E989', // Fill color
                fillOpacity: 0.5, // Fill transparency
              });

              // Display the polygon on the map
              polygon.setMap(map);
            }
          }
        });
      } else {
        // 지도 생성
        let map = new window.kakao.maps.Map(container, options);
        // 마커 추가 (옵션)

        const markerImage = new window.kakao.maps.MarkerImage(
          getMarkerImage(),
          new window.kakao.maps.Size(40, 46),
        );

        new window.kakao.maps.Marker({
          position: new window.kakao.maps.LatLng(lat, lng),
          map: map,
          image: markerImage,
        });
        // 폴리곤 생성
        if (geom.length > 0) {
          const polygonPath = geom.map(
            ([lng, lat]) => new window.kakao.maps.LatLng(lat, lng),
          );

          const polygon = new window.kakao.maps.Polygon({
            path: polygonPath, // Define the polygon path
            strokeWeight: 3, // Border thickness
            strokeColor: '#00B155', // Border color
            strokeOpacity: 0.8, // Border transparency
            fillColor: '#00E989', // Fill color
            fillOpacity: 0.5, // Fill transparency
          });

          // Display the polygon on the map
          polygon.setMap(map);
        }
      }
    }
  }, [roadView]);

  return (
    <Container>
      <MapContainer id="StateMap" roadView={roadView}></MapContainer>
      <ExpandButton   onClick={() => {
    const url = `/fullscreenMap?lat=${lat}&lng=${lng}&groupCategory=${groupCategory}&geom=${geom}`;
    window.open(url, '_blank');
  }}>
        <img src={expandIcon} alt="확대하기" />
      </ExpandButton>
      <RoadViewButton>
        <div>로드뷰</div>
        <img
          style={{ cursor: 'pointer' }}
          src={`/assets/images/icon/${isEnableRoadView && roadView ? 'toggleOn-text' : 'toggleOff-text'}.svg`}
          alt=""
          onClick={() => {
            if (!isEnableRoadView) {
              return;
            }
            setRoadView(!roadView);
          }}
        />
      </RoadViewButton>
    </Container>
  );
};

const MarkerImage = (category: string) => {};

export default ItemStateMap;

interface MapContainerProps {
  roadView: boolean;
}

const MapContainer = styled.div<MapContainerProps>`
  width: 100%;
  height: 164px;
  text-align: center !important;
  display: flex;

  /*로드뷰에서 나치반을 없에는 css*/
  [id^='_box_util_'] {
    display: none !important;
  }

  /*
      text-align=left로 인해 로드뷰의 나침반의 위치가 이상해지는 것을 수정하는 css
      만약 나침반을 살린다고 한다면 필요
      [id^='StateMap'] {
        text-align: center !important;
      }

      자식 요소가 상속받지 않도록 설정
      [id^='StateMap'] * {
        text-align: center !important;
      }
        */
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  text-align: center !important;
`;

const RoadViewButton = styled.div`
  width: 105px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.68);
  position: absolute;
  bottom: 24px;
  right: 12px;
  border-radius: 9999px;
  padding: 6px 8px;
  display: flex;
  flex-direction: row;
  z-index: 2;
  gap: 8px;
  justify-content: space-between;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08);
  color: white;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
`;


const ExpandButton = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  cursor: pointer;
  `